import React from 'react';
import ArticleWrapper from '../../components/ArticleWrapper';

const GMKDigitalNightmares = () => (
  <ArticleWrapper articleId="gmk_digital_nightmares">
    <div className="min-h-screen bg-[#111112] flex flex-col w-full">
      <div className="prose prose-invert mx-auto p-6">
        <h1>GMK Digital Nightmares</h1>
        {/* Add your GMK Digital Nightmares article content here */}
        <p>This is a placeholder article for the GMK Digital Nightmares keycap set. More content coming soon.</p>
      </div>
    </div>
  </ArticleWrapper>
);

export default GMKDigitalNightmares;
